/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import cx from 'classnames';

import {
  Input,
  Radio,
  Navigation,
  KeyboardNav,
} from '../../../../../components/shared';

import styles from '../../../Forms.scss';
import stylesForm from '../../../../../components/shared/Form/Form.scss';

export const tourGuideNeededList = [
  {
    id: 'yes',
    label: 'Yes',
  },
  {
    id: 'no',
    label: 'No',
  },
];

const TourGuideNeeded = ({ setForm, formData, navigation, step, index }) => {
  const { tourNeeded } = formData;
  const { next, previous } = navigation;
  const [isValid, setIsValid] = useState(false);
  KeyboardNav(step, isValid, navigation);

  useEffect(() => {
    if (tourNeeded !== '') {
      setIsValid(true);
    } else {
      setIsValid(false);
    }
  }, [formData, isValid]);

  return (
    <div>
      <h4>
        <span>{index + 1}</span> Tour Needed? *
      </h4>

      <div className={cx(styles.form__multiple, styles.form__multiple__col1)}>
        {tourGuideNeededList.map(type => {
          const { id, label } = type;

          return (
            <Radio
              id={id}
              key={id}
              label={label}
              name="tourNeeded"
              value={id}
              checked={tourNeeded === id}
              onChange={setForm}
              type="radio"
            />
          );
        })}
      </div>

      <Navigation navigation={navigation} isValid={isValid} />
    </div>
  );
};

export default TourGuideNeeded;
